import React from 'react';
import { cn } from '../../../lib/utils';

export interface ThreePaneProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * ThreePane Layout - Header, Content, Footer structure
 * Provides consistent page layout with optional header and footer slots
 */
export const ThreePane = React.forwardRef<HTMLDivElement, ThreePaneProps>(
  ({ header, footer, children, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('flex flex-col w-full', className)}
      >
        {header && (
          <header className="flex-shrink-0">
            {header}
          </header>
        )}
        <main className="flex-1 flex w-full overflow-hidden flex-col min-h-0">
          {children}
        </main>
        {footer && (
          <footer className="flex-shrink-0">
            {footer}
          </footer>
        )}
      </div>
    );
  }
);

ThreePane.displayName = 'ThreePane';
